import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DropdownOverlayService {
    private dropdownOverlayElement: HTMLDivElement;

    constructor() {
        this.init();
    }

    hide(): void {
        this.dropdownOverlayElement.style.display = 'none';
    }

    show(): void {
        setTimeout(() => {
            this.dropdownOverlayElement.style.display = 'block';
        }, 100);
    }

    private init(): void {
        this.dropdownOverlayElement = document.createElement('div');
        this.dropdownOverlayElement.setAttribute('id', 'dropdown-overlay');

        this.dropdownOverlayElement.style.display = 'none';
        this.dropdownOverlayElement.style.position = 'fixed';
        this.dropdownOverlayElement.style.height = '100%';
        this.dropdownOverlayElement.style.width = '100%';
        this.dropdownOverlayElement.style.left = '0';
        this.dropdownOverlayElement.style.top = '0';
        this.dropdownOverlayElement.style.pointerEvents = 'none';
        this.dropdownOverlayElement.style.zIndex = '9000';

        this.hide = this.hide.bind(this);
        this.dropdownOverlayElement.addEventListener('click', this.hide);

        document.body.append(this.dropdownOverlayElement);
    }
}
